import { render, staticRenderFns } from "./Cashiers.vue?vue&type=template&id=068a388a&"
import script from "./Cashiers.vue?vue&type=script&lang=js&"
export * from "./Cashiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports